import {Fragment, useEffect} from "react";
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import {App as AntdApp} from "antd";
import {privateRoutes, publicRoutes, PrivateRoutes} from "~/routes";
import RequireCap from "~/routes/RequireCap";
import {DefaultLayout} from "~/layout";
import {GlobalHistory} from "~/routes/GlobalHistory";
import {useCurrentUser} from "~/hooks";
import {bindNotification} from "~/utils";

function resolveLayout(route) {
  if (route.layout) return route.layout;
  if (route.layout === null) return Fragment;
  return DefaultLayout;
}

function App() {

  const {notification} = AntdApp.useApp();

  useCurrentUser();

  // Gắn instance notification có context theme cho code ngoài component (apiError).
  useEffect(() => { bindNotification(notification); }, [notification])

  useEffect(() => { document.title = "Omni SEO"; }, [])

  return (
      <Router>
        <GlobalHistory />
        <div className="App">
          <Routes>
            {publicRoutes.map((route) => {
              const Layout = resolveLayout(route);
              const Page = route.component;
              return (
                  <Route key={route.path} path={route.path} element={<Layout><Page /></Layout>}/>
              )
            })}
            {privateRoutes.map((route) => {
              const Layout = resolveLayout(route);
              const Page = route.component;
              // Route có `cap` → gate quyền, không đủ quyền hiện màn NoPermission (giữ layout/sidebar).
              const page = route.cap ? <RequireCap cap={route.cap}><Page /></RequireCap> : <Page />;
              return (
                  <Route key={route.path} path={route.path} element={<PrivateRoutes><Layout>{page}</Layout></PrivateRoutes>}/>
              )
            })}
          </Routes>
        </div>
      </Router>
  );
}

export default App;
